// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
export const SAMPLE_DATA_MODULES = [
    { key: 'rights_requests', module_id: 'rights_requests', in_demo_seed: true },
    { key: 'data_mapping', module_id: 'data_mapping', in_demo_seed: true },
    { key: 'data_subjects', module_id: 'data_subjects', in_demo_seed: false },
    { key: 'governance', module_id: 'governance', in_demo_seed: true },
    { key: 'consent', module_id: 'consent', in_demo_seed: true },
    { key: 'consent_properties', module_id: 'consent_properties', in_demo_seed: false },
    { key: 'assessments', module_id: 'assessments', in_demo_seed: true },
    { key: 'classification', module_id: 'classification', in_demo_seed: true },
    { key: 'monitoring', module_id: 'monitoring', in_demo_seed: true },
    { key: 'incidents', module_id: 'incidents', in_demo_seed: true },
    { key: 'incident_ops', module_id: 'incident_ops', in_demo_seed: false },
    { key: 'vendor_risk', module_id: 'vendor_risk', in_demo_seed: false },
    { key: 'deletion_orch', module_id: 'deletion_orchestration', in_demo_seed: false },
    { key: 'program_governance', module_id: 'program_governance', in_demo_seed: false },
    { key: 'task_management', module_id: 'task_management', in_demo_seed: false },
    { key: 'forms', module_id: 'compliance_forms', in_demo_seed: true },
    { key: 'discovery', module_id: 'discovery', in_demo_seed: false },
    { key: 'connectors', module_id: 'connectors', in_demo_seed: false },
    { key: 'access_accountability', module_id: 'access_accountability', in_demo_seed: true },
    { key: 'partner_marketplace', module_id: 'partner_workspace', in_demo_seed: false },
    { key: 'audit_trail', module_id: 'audit_trail', in_demo_seed: false },
];
/** Every sample-data module key, in display order. */
export const SAMPLE_DATA_MODULE_KEYS = SAMPLE_DATA_MODULES.map((m) => m.key);
/** Sample-data key → the platform module its records belong to. */
export const SAMPLE_DATA_MODULE_TO_MODULE_ID = Object.fromEntries(SAMPLE_DATA_MODULES.map((m) => [m.key, m.module_id]));
/** The modules `db/seed.ts` loads for a demo-mode org. */
export const SAMPLE_DATA_DEMO_SEED_MODULES = SAMPLE_DATA_MODULES.filter((m) => m.in_demo_seed).map((m) => m.key);
/** Whether a string is a sample-data module key. */
export function isSampleDataModule(value) {
    return SAMPLE_DATA_MODULE_KEYS.includes(value);
}
/** The sample-data key whose records belong to `moduleId`, or `undefined`. */
export function sampleDataModuleForModuleId(moduleId) {
    return SAMPLE_DATA_MODULES.find((m) => m.module_id === moduleId)?.key;
}
/**
 * The marker on every sample-data row, cross-industry and industry package
 * alike. Sprint 63.26.0 (B3): an industry package's rows also carry
 * `_sample_package` and `_sample_package_version`, which is what tells the two
 * apart; this value is the one both writers stamp.
 */
export const SAMPLE_DATA_ROW_TAG = '__sample_data__';
/**
 * Sprint 63.37.0 (H1, I3) — whether a stored row is sample data: it carries the
 * {@link SAMPLE_DATA_ROW_TAG} marker every sample-data writer stamps on `_sample`,
 * or a read already decided it (`is_sample: true`, as `GET /forms/instances/:id`
 * reports it). The printed form's synthetic stamp and the pages' Sample marker
 * ask this one question, so a row cannot be stamped on one surface and unmarked
 * on another.
 */
export function isSampleDataRow(row) {
    if (!row || typeof row !== 'object')
        return false;
    const r = row;
    return r.is_sample === true || r._sample === SAMPLE_DATA_ROW_TAG || r._sample === true;
}
//# sourceMappingURL=sample-data-modules.js.map